// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + "ea88be26" + "." + "f01b55a6b985c1714bc8" + ".js";
};